import { CsvHeaderModel } from '../../../models/CsvHeader';

export const CSV_ORDER_HEADER: CsvHeaderModel[] = [
  {
    label: 'Order No',
    key: 'order_no',
  },
  {
    label: 'Order Number',
    key: 'order_number',
  },
  {
    label: 'Shipment Method',
    key: 'shipment_method',
  },
  {
    label: 'Payment Method',
    key: 'payment_method',
  },
  {
    label: 'Total Unit',
    key: 'total_unit',
  },
  {
    label: 'Status',
    key: 'status',
  },
  {
    label: 'is rider assist',
    key: 'riderAssist',
  },
  {
    label: 'rider detail',
    key: 'riderDetail',
  },
  {
    label: 'Order Time',
    key: 'order_time',
  },
  {
    label: 'Latest Update',
    key: 'latest_update',
  },
  {
    label: 'Total Product Price',
    key: 'total_product_price',
  },
  {
    label: 'Vax',
    key: 'vax',
  },
  {
    label: 'Delivery Fee',
    key: 'delivery_fee',
  },
  {
    label: 'Discount From Promotion',
    key: 'discount_from_promotion',
  },
  {
    label: 'Discount From Coupon',
    key: 'discount_from_coupon',
  },
  {
    label: 'Total',
    key: 'total',
  },
  {
    label: 'Merchant Store',
    key: 'merchant_store',
  },
  {
    label: 'Merchant Store',
    key: 'merchant_store',
  },
  {
    label: 'Product',
    key: 'product',
  },
  {
    label: 'Barcode',
    key: 'barcode',
  },
  {
    label: 'Item code',
    key: 'item_code',
  },
  {
    label: 'Product Quantity',
    key: 'product_quantity',
  },
  // {
  //   label: 'Main Group',
  //   key: 'main_group',
  // },
  // {
  //   label: 'Division',
  //   key: 'division',
  // },
  // {
  //   label: 'Category',
  //   key: 'category',
  // },
  // {
  //   label: 'Sub Category',
  //   key: 'sub_category',
  // },
  {
    label: 'Product Price',
    key: 'product_price',
  },
  {
    label: 'Discount',
    key: 'discount',
  },
  {
    label: 'Promotion',
    key: 'promotion',
  },
  {
    label: 'Total Product',
    key: 'total_product',
  },
];
